import { isSamePackage, getPackageNameVersionAndHash } from "@/utils/mdc";
import { postApi } from "@/utils/http";
import store from "@/store/index";

export async function getComputerPackages(item, computerUIDs, domainUID) {
  const { hash } = getPackageNameVersionAndHash(item);
  const res = await postApi("get/computerPackagesSlim", {
    packageHash: hash,
    computerUIDs,
    domainUID,
  });

  return res[0];
}

export function getPackageStats(groupPackages, computers, item) {
  let stats = {};
  const packagesToFilter = groupPackages.filter((x) =>
    isSamePackage(x, item, true)
  );

  const installed = packagesToFilter.filter(
    (x) => x.command.status === "done" && x.command.name !== "uninstall"
  );
  const uninstalled = packagesToFilter.filter(
    (x) => x.command.status === "done" && x.command.name === "uninstall"
  );
  const pending = packagesToFilter.filter(
    (x) => x.command.status === "pending"
  );
  const failed = packagesToFilter.filter((x) => x.command.status === "failed");
  const working = packagesToFilter.filter(
    (x) => x.command.status === "working"
  );

  let allDone = false;

  let procentDone = 0;
  let procentFailed = 0;
  let procentWorking = 0;
  let procentInstalled = 0;
  let procentUninstalled = 0;

  let totalDone = 0;

  let totalInstalled = 0;
  let installedComputerUIDs = [];

  let totalFailed = 0;
  let failedComputerUIDs = [];

  let totalWorking = 0;
  let workingComputerUIDs = [];

  let totalPending = 0;
  let pendingComputerUIDs = [];

  let totalUninstalled = 0;
  let uninstalledComputerUIDs = [];

  let totalNoStatus = 0;
  let procentNoStatus = 0;
  let noStatusComputerUIDs = [];

  let totalComputers = computers.length;

  const procentTotalComputers = 100 / totalComputers;

  if (installed.length > 0) {
    totalInstalled = installed.length;
    installedComputerUIDs = installed.map((p) => p.computerUID);
  }

  if (failed.length > 0) {
    totalFailed = failed.length;
    failedComputerUIDs = failed.map((p) => p.computerUID);
  }

  if (working.length > 0) {
    totalWorking = working.length;
    workingComputerUIDs = working.map((p) => p.computerUID);
  }

  if (pending.length > 0) {
    totalPending = pending.length;
    pendingComputerUIDs = pending.map((p) => p.computerUID);
  }

  if (uninstalled.length > 0) {
    totalUninstalled = uninstalled.length;
    uninstalledComputerUIDs = uninstalled.map((p) => p.computerUID);
  }

  noStatusComputerUIDs = computers.map((x) => x.uid);

  for (const uid of installedComputerUIDs) {
    const index = noStatusComputerUIDs.indexOf(uid);
    if (index != -1) noStatusComputerUIDs.splice(index, 1);
  }

  for (const uid of uninstalledComputerUIDs) {
    const index = noStatusComputerUIDs.indexOf(uid);
    if (index != -1) noStatusComputerUIDs.splice(index, 1);
  }

  for (const uid of failedComputerUIDs) {
    const index = noStatusComputerUIDs.indexOf(uid);
    if (index != -1) noStatusComputerUIDs.splice(index, 1);
  }

  for (const uid of workingComputerUIDs) {
    const index = noStatusComputerUIDs.indexOf(uid);
    if (index != -1) noStatusComputerUIDs.splice(index, 1);
  }

  if (
    (totalInstalled === totalComputers && item.command.name === "install") ||
    (totalInstalled === totalComputers && item.command.name === "upgrade") ||
    (totalUninstalled === totalComputers && item.command.name === "uninstall")
  )
    allDone = true;

  if (item.command.name === "install" || item.command.name === "upgrade")
    totalDone = totalInstalled;
  else if (item.command.name === "uninstall") totalDone = totalUninstalled;

  if (item.command.name === "install" || item.command.name === "upgrade")
    procentDone = procentTotalComputers * totalInstalled;
  else if (item.command.name === "uninstall")
    procentDone = procentTotalComputers * totalUninstalled;

  procentDone = Math.round(procentDone);

  procentFailed = procentTotalComputers * totalFailed;
  procentFailed = Math.round(procentFailed);

  procentInstalled = procentInstalled = procentTotalComputers * totalInstalled;
  procentInstalled = Math.round(procentInstalled);

  procentUninstalled = procentUninstalled =
    procentTotalComputers * totalUninstalled;
  procentUninstalled = Math.round(procentUninstalled);

  procentWorking = procentWorking = procentTotalComputers * totalWorking;
  procentWorking = Math.round(procentWorking);

  totalNoStatus =
    totalComputers -
    totalWorking -
    totalFailed -
    totalInstalled -
    totalUninstalled;

  procentNoStatus = procentTotalComputers * totalNoStatus;
  procentNoStatus = Math.round(procentNoStatus);

  stats = {
    totalDone,
    allDone,
    procentDone,
    procentFailed,
    procentInstalled,
    procentUninstalled,
    procentWorking,
    totalComputers,
    totalInstalled,
    installedComputerUIDs,
    totalWorking,
    workingComputerUIDs,
    totalUninstalled,
    uninstalledComputerUIDs,
    totalPending,
    pendingComputerUIDs,
    totalFailed,
    failedComputerUIDs,
    totalNoStatus,
    procentNoStatus,
    noStatusComputerUIDs,
  };

  stats.installedComputers = getComputersFromUIDs(
    stats.installedComputerUIDs,
    computers
  );
  stats.failedComputers = getComputersFromUIDs(
    stats.failedComputerUIDs,
    computers
  );
  stats.workingComputers = getComputersFromUIDs(
    stats.workingComputerUIDs,
    computers
  );
  stats.pendingComputers = getComputersFromUIDs(
    stats.pendingComputerUIDs,
    computers
  );
  stats.uninstalledComputers = getComputersFromUIDs(
    stats.uninstalledComputerUIDs,
    computers
  );
  stats.noStatusComputers = getComputersFromUIDs(
    stats.noStatusComputerUIDs,
    computers
  );

  return stats;
}

export function fetchPackagesStats(
  groupPackages,
  group,
  domainUID,
  force,
  addToStore
) {
  if (group && group.computers) {
    groupPackages = [...groupPackages];
    const computerUIDs = group.computers.map((x) => x.uid);
    const promises = [];

    for (const item of groupPackages) {
      if (
        !item.stats ||
        force ||
        (item.command && item.command.name && !force)
      ) {
        const promise = getComputerPackages(item, computerUIDs, domainUID)
          .then((computerPackageInfo) => {
            if (addToStore) {
              store.commit(
                "groupPackage/setComputerPackages",
                computerPackageInfo
              );
            }

            return getPackageStats(
              computerPackageInfo.packages,
              group.computers,
              item
            );
          })
          .then((stats) => {
            store.commit("groupPackage/editMergedPackage", {
              p: item,
              obj: { stats: stats },
            });
          });

        promises.push(promise);
      }
    }
    return Promise.all(promises);
  }

  return [];
}

function getComputersFromUIDs(computerUIDs, groupComputers) {
  let computers = [];
  if (computerUIDs) {
    for (const computerUID of computerUIDs) {
      computers = [
        ...computers,
        ...groupComputers.filter((x) => x.uid === computerUID),
      ];
    }
  }

  return computers;
}
